let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("kT3yw")).then(() => parcelRequire('dMwVQ'));